import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { hideModal } from "../../../actions/actionCreators";
import { clearTreeSearch } from "../../../actions/searchActions";
import withModal from "../withModal";
import TreesWithSearch from "../../tree/TreesWithSearch";
import MaterialModal from "../MaterialModal";
import { IAppState } from "../../../types/stores";

type Props = {
    isOpen: boolean;
    modalProps?: {
        folderType: string;
        isMultiselect?: boolean;
        closeModal: (value?: string) => void;
    };
};

const TreeItemPickerModal: React.FC<Props> = ({ isOpen, modalProps }: Props) => {
    const dispatch = useDispatch();

    const selectedFlow = useSelector((state: IAppState) => state.selected.flow);

    const hide = () => {
        if (modalProps && modalProps.closeModal) {
            modalProps.closeModal(getSelectedValue());
        }
        dispatch(clearTreeSearch());
        dispatch(hideModal("TREE_ITEM_PICKER"));
    };

    const getSelectedValue = () => {
        if (!modalProps) {
            return null;
        }

        switch (modalProps.folderType) {
            case "W": {
                return selectedFlow ? selectedFlow.toString() : null;
            }
            default:
                return null;
        }
    };

    return modalProps ? (
        <MaterialModal
            isOpen={isOpen}
            title={modalProps.folderType == "W" && "Pick a Flow"}
            onClose={hide}
            id="tree-picker-modal"
            showPrimaryButton={false}
            cancelButtonText="Close"
        >
            <TreesWithSearch showFlowTree={modalProps.folderType == "W"} schedulesMode outerHeight="66vh" />
        </MaterialModal>
    ) : null;
};

export default withModal(TreeItemPickerModal, "TREE_ITEM_PICKER");
